/**
 * 全局错误捕获模块。
 *
 * 安装三种全局错误捕获：
 * 1. app.config.errorHandler — Vue 组件内未捕获错误
 * 2. window.addEventListener('error') — 全局 JS 错误
 * 3. window.addEventListener('unhandledrejection') — 未处理的 Promise 拒绝
 *
 * 每条日志附带 route 和 userAgent 上下文。
 */
import type { App } from 'vue'
import { createFrontendLogger } from './logger'

const logger = createFrontendLogger({ source: 'global-error' })

/** 安装全局错误捕获 */
export function installErrorCapture(app: App): void {
  // 1. Vue 组件内未捕获错误
  app.config.errorHandler = (err, instance, info) => {
    logger.error('Vue component error', {
      err: err instanceof Error ? err.message : String(err),
      stack: err instanceof Error ? err.stack : undefined,
      componentInfo: info,
      componentName: instance?.$options?.name ?? instance?.$options?.__name,
    })
  }

  // 2. 全局 JS 错误
  window.addEventListener('error', (event) => {
    logger.error('Uncaught error', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    })
  })

  // 3. 未处理的 Promise 拒绝
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason
    logger.error('Unhandled promise rejection', {
      reason: reason instanceof Error ? reason.message : String(reason),
      stack: reason instanceof Error ? reason.stack : undefined,
    })
  })
}
